export abstract class BaseDataModel {
	id!: string;
}
